import { inject, provide, type Component, type InjectionKey } from 'vue';

import type FIELD_RENDER_TYPES from '@/scripts/helpers/fieldRenderTypes';

export type FieldRenderers = Readonly<Partial<Record<FIELD_RENDER_TYPES, Component>>>;

const fieldRenderersKey: InjectionKey<FieldRenderers> = Symbol('fieldRenderers');

export const provideFieldRenderers = (renderers: FieldRenderers): void => {
    provide(fieldRenderersKey, { ...inject(fieldRenderersKey, {}), ...renderers });
};

export const useFieldRenderers = (): FieldRenderers => inject(fieldRenderersKey, {});
